import React from "react";
import { graphql } from "gatsby";
import styled from "styled-components";

import Layout from "../components/layout";
import SEO from "../components/seo";

const AboutSection = styled.section`
  padding-top: 7%;
  & > h1 {
    color: #2f2f2f;
    font-weight: 400;
  }
  & > h2 {
    font-weight: 300;
  }
`;

const AboutPage = ({ data, location }) => {
  const siteTitle = data.site.siteMetadata.title;
  return (
    <Layout location={location} title={siteTitle}>
      <SEO title="해외송금 모인 개발 블로그" />
      <AboutSection>
        <h1>고객 중심의 송금 서비스,</h1>
        <h1>모인이 시작합니다.</h1>

        <h2>모인 회사 소개</h2>
        <p style={{ paddingTop: "25px" }}>
          모인은 최적의 해외송금 솔루션을 제공하는 핀테크 회사입니다. 2016년 3월
          법인 설립을 시작으로 합리적인 가격으로 빠르고 편리한 송금 서비스를
          제공하고 있습니다.
          <br />
          모인은 비효율을 혁신적으로 해결하고, 사람을 위한 가치를 창출하고자
          하며, 무엇보다도 고객의 돈을 안전하게 보내는 것을 최우선으로 합니다.
          <br />
          <br />
          <span>
            모인은 2019년 6월 기준, 일본/중국/미국/싱가포르/호주/영국 송금
            서비스를 제공하고 있으며, 동남아시아, 유럽 등을 목표로 서비스를
            확장할 예정입니다. 앞으로도 모인은 해외송금 서비스에 대한 끊임없는
            연구를 통해 고객들에게 더 편리한 서비스를 제공할 수 있도록
            노력하겠습니다.
          </span>
        </p>

        <h2>모인의 미션</h2>
        <p style={{ paddingTop: "25px" }}>
          해외로 돈을 보낼 때 우리는 너무나도 당연하게 은행을 통해 송금을
          했습니다. 수수료가 비싸고 송금 하는데 오랜 시간이 걸린다는 것을
          알면서도, 왜 은행을 통할 수 밖에 없었을까요? 그건 은행만이 안전하게
          돈을 보낼 수 있는 유일한 송금 수단이라고 생각했기 때문입니다. 그래서
          우리는 기존의 문제점을 개선하면서 은행의 보안 수준을 맞춘 송금 방법을
          개발하고 싶다고 생각했습니다.
        </p>
        <h4>은행 중심이 아닌 사용자 중심의 송금서비스를 만들자</h4>
        <p>
          이것이 모인을 설립한 이유입니다. 우리는 모두가 안심하고 만족하는
          서비스를 제공하도록 노력할 것이며 해외 송금 시장을 더 나은 방향으로
          변화시키려 합니다.
        </p>
        <h1>모인은 솔직하고 투명합니다.</h1>
      </AboutSection>
    </Layout>
  );
};

export default AboutPage;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
